"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

var _RegistrationNew = _interopRequireDefault(require("../model/RegistrationNew"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
* Registration service.
* @module api/RegistrationApi
* @version 1.0.0
*/
var RegistrationApi = /*#__PURE__*/function () {
  /**
  * Constructs a new RegistrationApi. 
  * @alias module:api/RegistrationApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function RegistrationApi(apiClient) {
    _classCallCheck(this, RegistrationApi);

    this.apiClient = apiClient || _ApiClient.default.instance;
  }
  /**
   * create registration
   * @param {Object} opts Optional parameters
   * @param {module:model/RegistrationNew} opts.registrationNew 
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/RegistrationNew} and HTTP response
   */


  _createClass(RegistrationApi, [{
    key: "apiV1RegistrationsPostWithHttpInfo",
    value: function apiV1RegistrationsPostWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['registrationNew'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _RegistrationNew.default;
      return this.apiClient.callApi('/api/v1/registrations', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * create registration
     * @param {Object} opts Optional parameters
     * @param {module:model/RegistrationNew} opts.registrationNew 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/RegistrationNew}
     */

  }, {
    key: "apiV1RegistrationsPost",
    value: function apiV1RegistrationsPost(opts) {
      return this.apiV1RegistrationsPostWithHttpInfo(opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
  }]);

  return RegistrationApi;
}();

exports.default = RegistrationApi;